import { render, staticRenderFns } from "./turrezervasyonekhizmetler.vue?vue&type=template&id=d9978b44&"
import script from "./turrezervasyonekhizmetler.vue?vue&type=script&lang=js&"
export * from "./turrezervasyonekhizmetler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports